// import { useEffect } from 'react';

// const CourseStructureInfo = ({
//   formData,
//   setFormData,
//   departments = [],
//   courses = [],
//   fetchCoursesByDepartment,
//   setDisable,
// }) => {
//   // 🔐 Step validation
//   useEffect(() => {
//     if (
//       formData.name &&
//       formData.department &&
//       formData.courses.length > 0
//     ) {
//       setDisable(false);
//     } else {
//       setDisable(true);
//     }
//   }, [formData, setDisable]);

//   // 🔁 Toggle course selection
//   const toggleCourse = (courseId) => {
//     setFormData((prev) => ({
//       ...prev,
//       courses: prev.courses.includes(courseId)
//         ? prev.courses.filter((id) => id !== courseId)
//         : [...prev.courses, courseId],
//     }));
//   };

//   return (
//     <div className="rounded-xl bg-white p-6 shadow">
//       <h3 className="mb-4 text-xl font-bold text-navy-700">
//         Course Structure Details
//       </h3>

//       {/* ================= STRUCTURE NAME ================= */}
//       <label className="mb-1 block font-medium">
//         Course Structure Name
//       </label>
//       <input
//         type="text"
//         placeholder="Windows + Networking"
//         value={formData.name}
//         onChange={(e) =>
//           setFormData({ ...formData, name: e.target.value })
//         }
//         className="mb-4 w-full rounded border p-3 outline-none"
//       />

//       {/* ================= DEPARTMENT ================= */}
//       <label className="mb-1 block font-medium">
//         Select Department
//       </label>
//       <select
//         value={formData.department}
//         onChange={(e) => {
//           const deptId = e.target.value;

//           setFormData({
//             ...formData,
//             department: deptId,
//             courses: [],
//           });

//           if (deptId) {
//             fetchCoursesByDepartment(deptId);
//           }
//         }}
//         className="mb-2 w-full rounded border p-3 outline-none"
//       >
//         <option value="">Select Department</option>

//         {departments.map((dept) => (
//           <option key={dept._id} value={dept._id}>
//             {dept.name}
//           </option>
//         ))}
//       </select>

//       {departments.length === 0 && (
//         <p className="text-sm text-gray-500">
//           Loading departments...
//         </p>
//       )}

//       {/* ================= COURSES ================= */}
//       {courses.length > 0 && (
//         <>
//           <label className="mt-4 mb-2 block font-medium">
//             Select Courses
//           </label>

//           <div className="grid grid-cols-2 gap-3">
//             {courses.map((course) => (
//               <label
//                 key={course._id}
//                 className="flex items-center gap-2 rounded border p-2"
//               >
//                 <input
//                   type="checkbox"
//                   checked={formData.courses.includes(course._id)}
//                   onChange={() => toggleCourse(course._id)}
//                 />
//                 <span>{course.courseName}</span>
//               </label>
//             ))}
//           </div>
//         </>
//       )}

//       {/* ================= EMPTY COURSES ================= */}
//       {formData.department && courses.length === 0 && (
//         <p className="mt-2 text-sm text-gray-500">
//           No courses found for this department
//         </p>
//       )}
//     </div>
//   );
// };

// export default CourseStructureInfo;

import { useEffect } from 'react';

const BatchStructureInfo = ({
  formData,
  setFormData,
  departments = [],
  courses = [],
  fetchCoursesByDepartment,
  setDisable,
}) => {
  /* ================= STEP VALIDATION ================= */
  useEffect(() => {
    if (formData.name && formData.department && formData.courses.length > 0) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [formData, setDisable]);

  /* ================= TOGGLE COURSE ================= */
  const toggleCourse = (courseId) => {
    setFormData((prev) => ({
      ...prev,
      courses: prev.courses.includes(courseId)
        ? prev.courses.filter((id) => id !== courseId)
        : [...prev.courses, courseId],
    }));
  };

  return (
    <div className="rounded-xl bg-white p-6 shadow">
      <h3 className="mb-4 text-xl font-bold text-navy-700">
        Batch Structure Details
      </h3>

      {/* ================= NAME ================= */}
      <label className="mb-1 block font-medium">Batch Structure Name</label>
      <input
        type="text"
        placeholder="Windows + Networking"
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        className="mb-4 w-full rounded border p-3 outline-none"
      />

      {/* ================= DEPARTMENT ================= */}
      <label className="mb-1 block font-medium">Select Department</label>
      <select
        value={formData.department}
        onChange={(e) => {
          const deptId = e.target.value;

          setFormData({
            ...formData,
            department: deptId,
            courses: [],
          });

          if (deptId) {
            fetchCoursesByDepartment(deptId);
          }
        }}
        className="mb-2 w-full rounded border p-3 outline-none"
      >
        <option value="">Select Department</option>

        {departments.map((dept) => (
          <option key={dept._id} value={dept._id}>
            {dept.name}
          </option>
        ))}
      </select>

      {departments.length === 0 && (
        <p className="text-sm text-gray-500">Loading departments...</p>
      )}

      {/* ================= COURSES ================= */}
      {courses.length > 0 && (
        <>
          <label className="mb-2 mt-4 block font-medium">Select Courses</label>

          <div className="grid grid-cols-2 gap-3">
            {courses.map((course) => (
              <label
                key={course._id}
                className="flex items-center gap-2 rounded border p-2"
              >
                <input
                  type="checkbox"
                  checked={formData.courses.includes(course._id)}
                  onChange={() => toggleCourse(course._id)}
                />
                <span>{course.courseName}</span>
              </label>
            ))}
          </div>
        </>
      )}

      {/* ================= EMPTY COURSES ================= */}
      {formData.department && courses.length === 0 && (
        <p className="mt-2 text-sm text-gray-500">
          No courses found for this department
        </p>
      )}
    </div>
  );
};

export default BatchStructureInfo;
